module.exports = __webpack_public_path__ + "static/img/OC_bg04.7930487.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/form/runtime/components/assets/OC_bg04.png
// module id = LhvZ
// module chunks = 7